import React, { Component } from 'react';
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import Loader from 'halogen/RingLoader';
import { connect } from 'react-redux';

class MemberCombobox extends Component {

  constructor(props) {
    super(props);
    this.state = {
      users: []
    };
    this.updateSelectedUser = this.updateSelectedUser.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.getUsers();
  }

  getUsers() {
    const users = [];

    if (this.props.members) {
      const members = this.props.members
      const keys = Object.keys(members)
      keys.forEach(key => {
        const u = Object.assign({id: key}, members[key]);
        users.push(u);
      })

      const selectedUserId = this.state.selectedUserId || users[0].id;
      this.setState({
        users: users,
        selectedUserId
      }, this.updateSelectedUser);
    }
  }

  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value
    }, this.updateSelectedUser);
  }

  updateSelectedUser() {
    this.props.onInputChange && this.props.onInputChange(
      this.state.selectedUserId
    );
  }

  render() {
    if (this.state.users.length === 0) {
      return (
        <div className="loader-wrapper" style={{height: '198px'}}>
          <Loader color="#26194b" size="60px" className="loader-small" />
        </div>
      )
    }

    const users = this.state.users.map((u) => {
      return (<option key={u.id} value={u.id}>{u.name}</option>)
    });

    return (
      <FormGroup controlId="user">
        <ControlLabel>
          { this.props.title
            ? (this.props.title)
            : ("User Name")
          }
        </ControlLabel>
        <FormControl id="user"
          name="selectedUserId"
          onChange={this.handleInputChange}
          value={this.state.selectedUserId}
          componentClass="select"
          placeholder="select">
          {users}
        </FormControl>
        <HelpBlock>
          { this.props.description
            ? (this.props.description)
            : ("Pick a user you wish to add Timeoff")
          }
        </HelpBlock>
      </FormGroup>
    )
  }
}

const mapStateToProps = (state) => {
  const { members } = state.auth;
  return { members };
}

export default connect(mapStateToProps)(MemberCombobox);



// WEBPACK FOOTER //
// ./src/components/MemberCombobox.js